import React, { useRef, useEffect } from "react";

// The dependency can now be an array of items to watch.
export function useChatScroll(dep: any[]): React.RefObject<HTMLDivElement> {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (ref.current) {
      ref.current.scrollIntoView({ behavior: "smooth", block: "end" });
    }
  }, [...dep]); // Use the spread operator to watch all items in the array

  return ref;
}
